import * as Sentry from '@sentry/react';

/** PII-free client failure dimensions for the booking-widget RTA flow. */
export interface RtaClientFailure {
  operation: 'eligibility' | 'submission';
  kind: 'http' | 'graphql' | 'malformed' | 'transport' | 'recaptcha';
  status?: number;
}

/** Injectable reporter contract used by RTA transport tests. */
export type RtaFailureReporter = (failure: RtaClientFailure) => void;

/** Report one structural RTA client failure without applicant or payload data. */
export const reportRtaClientFailure: RtaFailureReporter = (failure) => {
  Sentry.captureMessage('Booking widget RTA client failure', {
    level: 'error',
    tags: {
      rta_operation: failure.operation,
      rta_failure_kind: failure.kind,
    },
    extra: failure.status === undefined ? undefined : { http_status: failure.status },
  });
};
